export type { Allocated } from "@pdfking/wasm-core"
